export default __webpack_public_path__ + "static/media/3_derbysoft.0af69129.svg";